"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _styledReactModal = require("styled-react-modal");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ = require("../../..");

var _ShipmentDetailDialogStyles = require("../../styles/ShipmentDetailDialogStyles");

var _OrbitNetStyles = require("../../styles/OrbitNetStyles");

var _ShipmentTicketDetail = _interopRequireDefault(require("./ShipmentTicketDetail"));

var _ShipmentActions = _interopRequireDefault(require("./ShipmentActions"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Select = (0, _styledComponents["default"])(_.Select).withConfig({
  displayName: "ShipmentDetailDialog__Select",
  componentId: "sc-18trkfx-0"
})(["width:auto;"]);

var ShipmentDetailDialog = function ShipmentDetailDialog(_ref) {
  var show = _ref.show,
      className = _ref.className,
      id = _ref.id,
      number = _ref.number,
      tripTag = _ref.tripTag,
      status = _ref.status,
      expeditionClass = _ref.expeditionClass,
      expeditionClassIcon = _ref.expeditionClassIcon,
      alertIcon = _ref.alertIcon,
      courier = _ref.courier,
      tickets = _ref.tickets,
      actions = _ref.actions,
      onClose = _ref.onClose,
      primary = _ref.primary,
      secondary = _ref.secondary,
      detailButton = _ref.detailButton,
      altTrips = _ref.altTrips,
      onTripChange = _ref.onTripChange,
      _ref$order = _ref.order,
      order = _ref$order === void 0 ? {} : _ref$order,
      onBack = _ref.onBack;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      opacity = _useState2[0],
      setOpacity = _useState2[1];

  var _useState3 = (0, _react.useState)(tickets[0]),
      _useState4 = _slicedToArray(_useState3, 2),
      ticket = _useState4[0],
      setTicket = _useState4[1];

  var afterOpen = function afterOpen() {
    setTimeout(function () {
      setOpacity(1);
    }, 10);
  };

  var beforeClose = function beforeClose() {
    return new Promise(function (resolve) {
      setOpacity(0);
      setTimeout(resolve, 200);
    });
  };

  var configActionPrimary = primary || {
    caption: onBack != null ? 'Regresar' : 'Cerrar',
    onClick: function onClick() {
      onClose();

      if (onBack != null) {
        onBack();
      }
    },
    type: 'primary'
  };

  var trimString = function trimString(op) {
    var str = (op === null || op === void 0 ? void 0 : op.map(function (eq) {
      return eq.name;
    }).join(', ')) || '';
    return str.length > 30 ? str.substring(0, 30).concat('...') : str;
  };

  var handleTripChange = function handleTripChange(_ref2) {
    var tripId = _ref2.target.value;
    onTripChange && onTripChange(altTrips.find(function (trip) {
      return trip.tripId.toString() === tripId.toString();
    }));
  };

  var alertName = function alertName() {
    var _ticket$notificationC = ticket.notificationCenter,
        notificationCenter = _ticket$notificationC === void 0 ? [] : _ticket$notificationC;

    if (notificationCenter !== null && notificationCenter.length > 0) {
      var alert = notificationCenter[0].alert;
      return alert;
    }

    return '';
  };

  return /*#__PURE__*/_react["default"].createElement(_styledReactModal.ModalProvider, {
    style: {
      zIndex: 9999
    },
    backgroundComponent: _ShipmentDetailDialogStyles.FadingBackground
  }, /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.StyledModal, {
    isOpen: show,
    afterOpen: afterOpen,
    beforeClose: beforeClose,
    onEscapeKeydown: onClose,
    opacity: opacity,
    className: className,
    backgroundProps: {
      opacity: opacity
    }
  }, /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.ModalWrapper, {
    id: id
  }, /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.TitleWrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.IconClose, {
    onClick: onClose
  }, "x"), /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.Title, null, "Viaje No: ", " ", altTrips ? /*#__PURE__*/_react["default"].createElement(Select, {
    label: altTrips.find(function (aT) {
      return aT.tripId === id;
    }).tripCode,
    name: "tripId",
    items: altTrips.map(function (aT) {
      return {
        id: aT.tripId,
        description: aT.tripCode
      };
    }),
    value: id,
    onChange: handleTripChange
  }) : number, /*#__PURE__*/_react["default"].createElement("div", null, tripTag))), alertName() !== '' ? /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.WrapperAlertLabel, null, /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.TitleAlertLeft, null, "".concat(status.description)), /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.TitleAlertRight, null, "".concat(alertName()), alertName() !== '' ? alertIcon : null)) : /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.WrapperLabel, null, /*#__PURE__*/_react["default"].createElement(_OrbitNetStyles.LabelColor, {
    id: status.id,
    background: status.color,
    margin: "0 0.3rem 0 0",
    color: status.fontColor
  }, status.description), /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.TitleAlert, null, "".concat(alertName()), alertName() !== '' ? alertIcon : null)), /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.WrapperLabel, null, /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.TitleExpeditionClass, null, expeditionClassIcon, /*#__PURE__*/_react["default"].createElement("br", null), expeditionClass && "Clase ".concat(expeditionClass))), /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.CourierWrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.LogoWrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.CourierLogoFigure, null, /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.CourierLogoImg, {
    src: courier.logo
  })), /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.CourierName, null, courier.name || '')), /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.VehicleWrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.TitleExpeditionClass, {
    id: courier.vehicle ? courier.vehicle.id || '' : ''
  }, courier.vehicleIcon || '', courier.vehicle ? courier.vehicle.number || '' : ''), /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.TitleExpeditionClass, null, courier.equipmentIcon || '', courier.equipment && courier.equipment.length > 0 ? courier.equipment.map(function (eq) {
    return eq.number;
  }).join(', ') : ''), /*#__PURE__*/_react["default"].createElement(_ShipmentDetailDialogStyles.TitleExpeditionClass, null, courier.operatorIcon || '', courier.operator && courier.operator.length > 0 ? courier.operator.map(function (eq) {
    return eq.name;
  }).join(', ').length > 30 ? courier.operator.map(function (eq) {
    return eq.name;
  }).join(', ').substring(0, 30).concat('...') : courier.operator.map(function (eq) {
    return eq.name;
  }).join(', ') : ''))), /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetail["default"], {
    tickets: tickets,
    order: order,
    onChange: function onChange(ticket) {
      setTicket(ticket);
    }
  }), /*#__PURE__*/_react["default"].createElement(_ShipmentActions["default"], {
    ticket: ticket,
    actions: actions,
    primary: configActionPrimary,
    secondary: secondary
  }))));
};

ShipmentDetailDialog.propTypes = {
  show: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  id: _propTypes["default"].number.isRequired,
  number: _propTypes["default"].string.isRequired,
  status: _propTypes["default"].exact({
    id: _propTypes["default"].number,
    description: _propTypes["default"].string,
    color: _propTypes["default"].string,
    fontColor: _propTypes["default"].string
  }).isRequired,
  expeditionClass: _propTypes["default"].string,
  expeditionClassIcon: _propTypes["default"].any,
  alertName: _propTypes["default"].string,
  alertIcon: _propTypes["default"].any,
  courier: _propTypes["default"].exact({
    logo: _propTypes["default"].string,
    name: _propTypes["default"].string,
    vehicleIcon: _propTypes["default"].any,
    equipmentIcon: _propTypes["default"].any,
    operatorIcon: _propTypes["default"].any,
    vehicle: (0, _propTypes.exact)({
      id: _propTypes["default"].number,
      number: _propTypes["default"].string
    }),
    equipment: _propTypes["default"].arrayOf(_propTypes["default"].exact({
      id: _propTypes["default"].number,
      number: _propTypes["default"].string
    })),
    operator: (0, _propTypes.exact)({
      id: _propTypes["default"].number,
      name: _propTypes["default"].string
    })
  }),
  tickets: _propTypes["default"].arrayOf(_propTypes["default"].exact({
    id: _propTypes["default"].number,
    number: _propTypes["default"].string,
    origin: _propTypes["default"].exact({
      companyLogo: _propTypes["default"].string,
      location: _propTypes["default"].string,
      timedate: _propTypes["default"].string
    }),
    destination: _propTypes["default"].exact({
      companyLogo: _propTypes["default"].string,
      location: _propTypes["default"].string,
      timedate: _propTypes["default"].string
    }),
    level: _propTypes["default"].number,
    weight: _propTypes["default"].number,
    volume: _propTypes["default"].number,
    capacity: _propTypes["default"].number,
    weightIcon: _propTypes["default"].any,
    volumeIcon: _propTypes["default"].any,
    capacityIcon: _propTypes["default"].any,
    tags: _propTypes["default"].arrayOf(_propTypes["default"].exact({
      id: _propTypes["default"].number,
      description: _propTypes["default"].string
    }))
  })),
  actions: _propTypes["default"].arrayOf(_propTypes["default"].exact({
    caption: _propTypes["default"].string,
    onAction: _propTypes["default"].func
  })),
  onClose: _propTypes["default"].func,
  primary: _propTypes["default"].exact({
    caption: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    type: _propTypes["default"].string
  }),
  secondary: _propTypes["default"].exact({
    caption: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    type: _propTypes["default"].string
  })
};
ShipmentDetailDialog.defaultProps = {
  show: false,
  className: '',
  expeditionClass: '',
  expeditionClassIcon: null,
  alertIcon: null,
  courier: {},
  tickets: [],
  actions: [],
  onClose: function onClose() {},
  primary: null,
  secondary: null
};
var _default = ShipmentDetailDialog;
exports["default"] = _default;